import { render, staticRenderFns } from "./Dashboard.vue?vue&type=template&id=38058c52&scoped=true&"
import script from "./Dashboard.js?vue&type=script&lang=js&"
export * from "./Dashboard.js?vue&type=script&lang=js&"
import style0 from "./Dashboard.scss?vue&type=style&index=0&id=38058c52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38058c52",
  null
  
)

export default component.exports